import { apiPost } from "@/core/api";
import { Citizen, Core, Identification } from "@minicity/core";

export interface CreateApplicationRequest {
    citizenId: string;
    formData: Identification.FormData;
    supportDocuments: Core.Document[];
    
    draftApplicationId?: string;

    notificationPreferences: Citizen.NotificationPreferences;

    idempotencyToken: string;
}

export interface CreateApplicationResponse {
    birthRecordsApplicationId?: string;
    socialSecurityApplicationId?: string;
    notarizationRequired: boolean;
}

export const submitApplication = (req: CreateApplicationRequest) => {
    return apiPost<CreateApplicationResponse>("applications/identification", req);
}